<main class="text-start">
  <h1 class="page-title">
    <a [routerLink]="['/users']" class="text-[#8A8AA3] me-0.5 ms-2 hover:text-purple-800">
      <i class="bi" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
      {{ 'users_management.form.back' | translate }}
    </a>
    {{ (isEditMode ? 'users_management.form.title_edit' : 'users_management.form.title_add') | translate }}
  </h1>

  <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5 flex max-md:flex-col-reverse gap-4">

    <div class="md:w-2/3 w-full">
      <div *ngIf="loadingExisting" class="bg-white rounded-xl px-5 py-5">
        <div *ngFor="let _ of [1,2,3,4]" class="input-group-row mb-4">
          <div>
            <div class="h-3 w-24 bg-gray-200 rounded animate-pulse mb-3 me-auto"></div>
            <div class="h-10 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
          <div>
            <div class="h-3 w-24 bg-gray-200 rounded animate-pulse mb-3 me-auto"></div>
            <div class="h-10 bg-gray-200 rounded-md animate-pulse"></div>
          </div>
        </div>
        <div class="flex gap-3 mt-2">
          <div class="h-9 w-32 bg-gray-200 rounded-lg animate-pulse"></div>
          <div class="h-9 w-20 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>
      </div>

      <form *ngIf="!loadingExisting" #staffForm="ngForm" (ngSubmit)="submit(staffForm)" class="bg-white rounded-xl px-5 py-5">

        <div class="input-group-row">
          <div class="generic-input-group">
            <label for="first_name_ar">{{ 'users_management.form.fields.first_name_ar' | translate }} <span class="text-red-500">*</span></label>
            <input dir="auto" type="text" name="first_name_ar" id="first_name_ar"
              [(ngModel)]="form.first_name_ar" (ngModelChange)="clearFieldError('first_name_ar')"
              [class.field-error]="fieldErrors['first_name_ar']" required />
            <p *ngIf="fieldErrors['first_name_ar']" class="field-error-text">{{ fieldErrors['first_name_ar'][0] }}</p>
          </div>
          <div class="generic-input-group">
            <label for="last_name_ar">{{ 'users_management.form.fields.last_name_ar' | translate }} <span class="text-red-500">*</span></label>
            <input dir="auto" type="text" name="last_name_ar" id="last_name_ar"
              [(ngModel)]="form.last_name_ar" (ngModelChange)="clearFieldError('last_name_ar')"
              [class.field-error]="fieldErrors['last_name_ar']" required />
            <p *ngIf="fieldErrors['last_name_ar']" class="field-error-text">{{ fieldErrors['last_name_ar'][0] }}</p>
          </div>
        </div>

        <div class="input-group-row">
          <div class="generic-input-group">
            <label for="first_name">{{ 'users_management.form.fields.first_name' | translate }} <span class="text-red-500">*</span></label>
            <input dir="ltr" type="text" name="first_name" id="first_name"
              [(ngModel)]="form.first_name" (ngModelChange)="clearFieldError('first_name')"
              [class.field-error]="fieldErrors['first_name']" required />
            <p *ngIf="fieldErrors['first_name']" class="field-error-text">{{ fieldErrors['first_name'][0] }}</p>
          </div>
          <div class="generic-input-group">
            <label for="last_name">{{ 'users_management.form.fields.last_name' | translate }} <span class="text-red-500">*</span></label>
            <input dir="ltr" type="text" name="last_name" id="last_name"
              [(ngModel)]="form.last_name" (ngModelChange)="clearFieldError('last_name')"
              [class.field-error]="fieldErrors['last_name']" required />
            <p *ngIf="fieldErrors['last_name']" class="field-error-text">{{ fieldErrors['last_name'][0] }}</p>
          </div>
        </div>

        <div class="input-group-row">
          <div class="generic-input-group">
            <label for="staff_role">{{ 'users_management.form.fields.role' | translate }} <span class="text-red-500">*</span></label>
            <select name="staff_role" id="staff_role"
              [(ngModel)]="form.staff_role" (ngModelChange)="clearFieldError('staff_role')"
              [class.field-error]="fieldErrors['staff_role']" required>
              <option *ngFor="let r of staffRoles" [value]="r.value">{{ r.label | translate }}</option>
            </select>
            <p *ngIf="fieldErrors['staff_role']" class="field-error-text">{{ fieldErrors['staff_role'][0] }}</p>
          </div>
          <div class="generic-input-group">
            <label for="phone_number">{{ 'users_management.form.fields.phone' | translate }} <span class="text-red-500">*</span></label>
            <input dir="ltr" type="tel" name="phone_number" id="phone_number"
              [(ngModel)]="form.phone_number" (ngModelChange)="clearFieldError('phone_number')"
              [class.field-error]="fieldErrors['phone_number']" required />
            <p *ngIf="fieldErrors['phone_number']" class="field-error-text">{{ fieldErrors['phone_number'][0] }}</p>
          </div>
        </div>

        <div class="input-group-row">
          <div class="generic-input-group">
            <label for="password">
              {{ 'users_management.form.fields.password' | translate }}
              <span *ngIf="!isEditMode" class="text-red-500">*</span>
              <span *ngIf="isEditMode" class="text-[#8A8AA3] text-xs">{{ 'users_management.form.fields.password_optional_hint' | translate }}</span>
            </label>
            <div [dir]="isRTL ? 'rtl' : 'ltr'" class="relative w-full">
              <input [type]="showPassword ? 'text' : 'password'" name="password" id="password" autocomplete="new-password"
                [(ngModel)]="form.password" (ngModelChange)="clearFieldError('password')" class="ps-12"
                [class.field-error]="fieldErrors['password']" [required]="!isEditMode" minlength="8" />

              <span (click)="togglePassword()" class="absolute inset-y-8 end-4 flex items-center cursor-pointer">
                <ng-container *ngIf="!showPassword; else eyeSlash">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                      stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                      stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </ng-container>
                <ng-template #eyeSlash>
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                      stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                      stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M1 1L15 13" stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </ng-template>
              </span>
            </div>
            <p *ngIf="fieldErrors['password']" class="field-error-text">{{ fieldErrors['password'][0] }}</p>
          </div>
          <div class="generic-input-group">
            <label for="email">{{ 'users_management.form.fields.email' | translate }} <span class="text-red-500">*</span></label>
            <input dir="ltr" type="email" name="email" id="email"
              [(ngModel)]="form.email" (ngModelChange)="clearFieldError('email')"
              [class.field-error]="fieldErrors['email']" required email />
            <p *ngIf="fieldErrors['email']" class="field-error-text">{{ fieldErrors['email'][0] }}</p>
          </div>
        </div>

        <div *ngIf="fieldErrors['non_field_errors']" class="text-xs text-red-600 mb-3">
          {{ fieldErrors['non_field_errors'][0] }}
        </div>

        <div class="flex max-sm:flex-col justify-end gap-3 mt-2">
          <button type="button" (click)="cancel()"
            class="flex justify-center items-center gap-3 text-gray-800 disabled:text-gray-500 text-xs rounded-lg px-6 py-2 border border-gray-300 cursor-pointer disabled:cursor-auto"
            [disabled]="disableButtons">
            {{ 'users_management.form.actions.cancel' | translate }}
          </button>
          <button type="submit"
            class="flex justify-center items-center gap-2 bg-[#611F79] text-white text-xs rounded-lg px-5 py-2 disabled:opacity-60 cursor-pointer disabled:cursor-auto"
            [disabled]="disableButtons || loadingExisting">
            <span *ngIf="submitLoading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
            {{ (isEditMode ? 'users_management.form.actions.save' : 'users_management.form.actions.create') | translate }}
          </button>
        </div>

      </form>
    </div>

    <div class="md:w-1/3 w-full">
      <div class="bg-white rounded-xl p-4 py-5 flex flex-col items-center gap-4">
        <ng-container *ngIf="loadingExisting; else avatarUploader">
          <div class="w-32 h-32 rounded-full bg-gray-200 animate-pulse"></div>
          <div class="h-3 w-20 bg-gray-200 rounded animate-pulse"></div>
          <div class="h-8 w-24 bg-gray-200 rounded-full animate-pulse"></div>
        </ng-container>
        <ng-template #avatarUploader>
          <app-image-uploader
            [productImages]="form.profile_image ? [form.profile_image] : []"
            [maxImages]="1"
            [rounded]="true"
            type="staff-avatar"
            [title]="'users_management.form.profile_image' | translate"
            (imagesChange)="onProfileImageChange($event)">
          </app-image-uploader>
        </ng-template>
      </div>
    </div>
  </div>
</main>
